import { useOrganization, useOrganizationList } from '@clerk/clerk-react'
import { useAsyncState } from '@saaga/shared/hooks/use-async-state.hook'
import type { ReactNode } from 'react'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { LoadingScreen } from './loading-screen.atom'
import { getOrgGuardContent } from './organization-guard.helper'

export const OrganizationGuard = (): ReactNode => {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  const { organization: currentOrganization, isLoaded: orgLoaded } = useOrganization()
  const {
    isLoaded: orgListLoaded,
    setActive,
    userMemberships,
  } = useOrganizationList({
    userMemberships: { infinite: true },
  })

  const memberships = userMemberships?.data ?? []
  const targetMembership = memberships.find((m) => m.organization.slug === orgSlug)

  const switchOrgFn = useCallback(
    () =>
      setActive
        ? setActive({ organization: targetMembership?.organization.id ?? '' })
        : Promise.resolve(),
    [setActive, targetMembership?.organization.id]
  )

  const orgSwitch = useAsyncState(switchOrgFn, { resetKey: orgSlug })

  const content = getOrgGuardContent({
    orgLoaded,
    orgListLoaded,
    isMembershipsLoading: !userMemberships || userMemberships.isLoading,
    memberships,
    targetMembership,
    currentOrgSlug: currentOrganization?.slug ?? undefined,
    targetOrgSlug: orgSlug,
    orgSwitch,
  })

  if (content) {
    return content
  }

  if (orgSwitch.isIdle) {
    orgSwitch.execute()
  }

  return <LoadingScreen />
}
